import P from 'prop-types';
import { Box } from '@nerdwallet/currency';
import classes from '@nerdwallet/base-styles/classes';
import classNames from 'classnames';
import UniversalAuthButton from '../universal-auth-button/universal-auth-button';
import UniversalButton from '../universal-button/universal-button';
import UniversalText from '../universal-text/universal-text';

const BannerHorizontalContent = ({
  actionButtonProps,
  authButton,
  includeContentWidthLimitation,
  includeSignUpButtons,
  isSignedIn,
  subtitleProps,
  titleProps,
}) => {
  return (
    <Box
      className={classNames([
        'horizontal-banner__content',
        'centered-in-parent',
        { '_two-thirds': includeContentWidthLimitation },
      ])}
    >
      <UniversalText {...titleProps} />
      <UniversalText {...subtitleProps} />
      <Box
        className={classNames([
          classes('padding-top-4'),
          classes('padding-bottom-5--wide'),
          classes('padding-bottom-4'),
        ])}
      >
        {includeSignUpButtons && (
          <div className="horizontal-banner__sign-up centered-in-parent">
            <UniversalAuthButton {...authButton} isSignedIn={isSignedIn} />
          </div>
        )}
        {actionButtonProps?.buttonText && (
          <UniversalButton {...actionButtonProps} />
        )}
      </Box>
    </Box>
  );
};

BannerHorizontalContent.propTypes = {
  includeSignUpButtons: P.bool,
  includeContentWidthLimitation: P.bool,
  includeParentWithLimitation: P.bool,
  authButton: UniversalAuthButton.propTypes,
  actionButtonProps: UniversalButton.propTypes,
  isSignedIn: P.bool,
  titleProps: UniversalText.propTypes,
  subtitleProps: UniversalText.propTypes,
};

BannerHorizontalContent.defaultProps = {
  includeSignUpButtons: false,
  includeContentWidthLimitation: false,
  includeParentWithLimitation: false,
};

export default BannerHorizontalContent;
